import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "space-y-4 flex min-h-0 flex-1 flex-col"
};
const _hoisted_2 = {
  class: "grid gap-3 md:grid-cols-4"
};
const _hoisted_3 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_4 = {
  class: "mt-1 text-xl font-semibold text-slate-900"
};
const _hoisted_5 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_6 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_7 = {
  class: "data-table-shell border-none shadow-none"
};
const _hoisted_8 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_9 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_10 = {
  key: 0,
  class: "data-table-row"
};
const _hoisted_11 = {
  key: 1,
  class: "data-table-row"
};
const _hoisted_12 = {
  class: "data-table-td min-w-[240px]"
};
const _hoisted_13 = {
  class: "data-table-cell-title"
};
const _hoisted_14 = {
  class: "data-table-cell-meta"
};
const _hoisted_15 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_16 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_17 = {
  class: "data-table-td whitespace-nowrap font-mono text-xs text-slate-600"
};
const _hoisted_18 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_19 = {
  class: "data-table-td whitespace-nowrap text-slate-600"
};
const _hoisted_20 = {
  class: "data-table-td is-center whitespace-nowrap data-table-sticky-right data-table-sticky-action"
};
const _hoisted_21 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  key: 0,
  class: "space-y-6"
};
const _hoisted_28 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_29 = {
  class: "mt-4 grid grid-cols-2 gap-3 text-sm"
};
const _hoisted_30 = {
  class: "mt-1 text-slate-900"
};
const _hoisted_31 = {
  class: "mt-1 text-slate-900"
};
const _hoisted_32 = {
  class: "mt-1 text-slate-900"
};
const _hoisted_33 = {
  class: "mt-1 font-mono text-xs text-slate-900"
};
const _hoisted_34 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_35 = {
  class: "mt-3 space-y-2"
};
const _hoisted_36 = {
  class: "font-medium text-slate-900"
};
const _hoisted_37 = {
  class: "mt-1 text-slate-500"
};
const _hoisted_38 = {
  key: 0,
  class: "text-sm text-slate-500"
};
const _hoisted_39 = {
  class: "rounded-2xl border border-slate-200 p-4"
};
const _hoisted_40 = {
  class: "mt-3 space-y-2"
};
const _hoisted_41 = {
  class: "font-medium text-slate-900"
};
const _hoisted_42 = {
  class: "mt-1 text-slate-500"
};
const _hoisted_43 = {
  key: 0,
  class: "text-sm text-slate-500"
};
const _hoisted_44 = ["disabled"];
const _hoisted_45 = {
  class: "space-y-3"
};
const _hoisted_46 = ["onUpdate:modelValue"];
const _hoisted_47 = ["onUpdate:modelValue"];
const _hoisted_48 = ["onUpdate:modelValue"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = ["disabled"];
const _hoisted_51 = {
  class: "space-y-3"
};
const _hoisted_52 = ["onUpdate:modelValue"];
const _hoisted_53 = ["onUpdate:modelValue"];
const _hoisted_54 = ["onUpdate:modelValue"];
const _hoisted_55 = ["onUpdate:modelValue"];
const _hoisted_56 = ["onUpdate:modelValue"];
const _hoisted_57 = ["onClick"];
const _hoisted_58 = ["disabled"];
const _hoisted_59 = {
  class: "data-table-shell"
};
const _hoisted_60 = {
  class: "data-table-scroll"
};
const _hoisted_61 = {
  class: "data-table text-sm"
};
const _hoisted_62 = {
  class: "data-table-td font-mono text-xs"
};
const _hoisted_63 = {
  class: "data-table-td"
};
const _hoisted_64 = {
  class: "data-table-td"
};
const _hoisted_65 = {
  key: 0
};
import { computed, onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { createEsignTemplate, disableEsignTemplate, enableEsignTemplate, getEsignTemplateDetail, getEsignTemplatePage, getTencentEsignTemplates, saveEsignTemplateFields, saveEsignTemplateParties } from '@/api/esign';
import { blank, formatDateTime, normalizePage, readArray, templateStatusClass, templateStatusText } from './esign-utils';
export default {
  __name: 'EsignTemplateManagement',
  setup(__props) {
    const loading = ref(false);
    const submitting = ref(false);
    const list = ref([]);
    const detail = ref(null);
    const currentTemplate = ref(null);
    const tencentTemplates = ref([]);
    const detailVisible = ref(false);
    const createVisible = ref(false);
    const partiesVisible = ref(false);
    const fieldsVisible = ref(false);
    const tencentVisible = ref(false);
    const filters = reactive({
      keyword: '',
      templateType: '',
      status: ''
    });
    const pagination = ref({
      current: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const templateForm = reactive({
      templateCode: '',
      templateName: '',
      templateType: 'FILE',
      channel: 'TENCENT',
      tencentTemplateId: '',
      remark: ''
    });
    const partyRows = ref([]);
    const fieldRows = ref([]);
    const detailParties = computed(() => readArray(detail.value?.parties || detail.value?.partyList));
    const detailFields = computed(() => readArray(detail.value?.fields || detail.value?.fieldList));
    const summaryCards = computed(() => [{
      label: '当前页模板',
      value: list.value.length
    }, {
      label: '启用',
      value: list.value.filter(item => item.status === 'ENABLED').length
    }, {
      label: '草稿',
      value: list.value.filter(item => item.status === 'DRAFT').length
    }, {
      label: '停用',
      value: list.value.filter(item => item.status === 'DISABLED').length
    }]);
    const templateTypeText = type => ({
      FILE: '文件模板',
      TENCENT_TEMPLATE: '腾讯模板'
    })[type] || blank(type);
    const resetTemplateForm = () => Object.assign(templateForm, {
      templateCode: '',
      templateName: '',
      templateType: 'FILE',
      channel: 'TENCENT',
      tencentTemplateId: '',
      remark: ''
    });
    const fetchList = async () => {
      loading.value = true;
      try {
        const res = await getEsignTemplatePage({
          current: pagination.value.current,
          size: pagination.value.size,
          ...filters
        });
        const page = normalizePage(res, pagination.value);
        list.value = page.records;
        pagination.value = page.pagination;
      } catch (error) {
        ElMessage.error(error.message || '加载电子签模板失败');
      } finally {
        loading.value = false;
      }
    };
    const handleSearch = () => {
      pagination.value.current = 1;
      fetchList();
    };
    const handleReset = () => {
      Object.assign(filters, {
        keyword: '',
        templateType: '',
        status: ''
      });
      handleSearch();
    };
    const handlePageChange = page => {
      pagination.value.current = page;
      fetchList();
    };
    const handlePageSizeChange = size => {
      pagination.value.size = size;
      pagination.value.current = 1;
      fetchList();
    };
    const openCreate = () => {
      resetTemplateForm();
      createVisible.value = true;
    };
    const submitCreate = async () => {
      if (!templateForm.templateCode || !templateForm.templateName) {
        ElMessage.warning('请填写模板编码和模板名称');
        return;
      }
      submitting.value = true;
      try {
        await createEsignTemplate({
          ...templateForm
        });
        ElMessage.success('模板已创建');
        createVisible.value = false;
        fetchList();
      } catch (error) {
        ElMessage.error(error.message || '创建模板失败');
      } finally {
        submitting.value = false;
      }
    };
    const openDetail = async item => {
      detailVisible.value = true;
      detail.value = null;
      try {
        detail.value = await getEsignTemplateDetail(item.id);
      } catch (error) {
        ElMessage.error(error.message || '加载模板详情失败');
      }
    };
    const toggleTemplate = async (item, enabled) => {
      await ElMessageBox.confirm(`确认${enabled ? '启用' : '停用'}模板「${item.templateName || item.templateCode}」吗？`, enabled ? '启用模板' : '停用模板', {
        type: 'warning'
      });
      try {
        if (enabled) await enableEsignTemplate(item.id);else await disableEsignTemplate(item.id);
        ElMessage.success(enabled ? '模板已启用' : '模板已停用');
        fetchList();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    };
    const openParties = item => {
      currentTemplate.value = item;
      partyRows.value = readArray(item.parties || item.partyList).map((party, index) => ({
        key: `${Date.now()}-${index}`,
        ...party
      }));
      if (!partyRows.value.length) addParty();
      partiesVisible.value = true;
    };
    const addParty = () => partyRows.value.push({
      key: `${Date.now()}-${Math.random()}`,
      roleCode: '',
      roleName: '',
      subjectType: 'PERSON',
      approverType: 'PERSON',
      signOrder: partyRows.value.length + 1
    });
    const removeParty = index => partyRows.value.splice(index, 1);
    const submitParties = async () => {
      submitting.value = true;
      try {
        const parties = partyRows.value.map(row => {
          const party = {
            ...row
          };
          delete party.key;
          return party;
        }).filter(party => party.roleCode || party.roleName);
        await saveEsignTemplateParties(currentTemplate.value.id, {
          parties
        });
        ElMessage.success('签署方配置已保存');
        partiesVisible.value = false;
        fetchList();
      } catch (error) {
        ElMessage.error(error.message || '保存签署方失败');
      } finally {
        submitting.value = false;
      }
    };
    const openFields = item => {
      currentTemplate.value = item;
      fieldRows.value = readArray(item.fields || item.fieldList).map((field, index) => ({
        key: `${Date.now()}-${index}`,
        ...field
      }));
      if (!fieldRows.value.length) addField();
      fieldsVisible.value = true;
    };
    const addField = () => fieldRows.value.push({
      key: `${Date.now()}-${Math.random()}`,
      fieldCode: '',
      fieldName: '',
      fieldType: 'TEXT',
      generateMode: 'POSITION',
      componentId: '',
      pageNo: 1,
      defaultValue: ''
    });
    const removeField = index => fieldRows.value.splice(index, 1);
    const submitFields = async () => {
      submitting.value = true;
      try {
        const fields = fieldRows.value.map(row => {
          const field = {
            ...row
          };
          delete field.key;
          return field;
        }).filter(field => field.fieldCode || field.fieldName);
        await saveEsignTemplateFields(currentTemplate.value.id, {
          fields
        });
        ElMessage.success('控件配置已保存');
        fieldsVisible.value = false;
        fetchList();
      } catch (error) {
        ElMessage.error(error.message || '保存控件失败');
      } finally {
        submitting.value = false;
      }
    };
    const loadTencentTemplates = async () => {
      try {
        const res = await getTencentEsignTemplates({});
        tencentTemplates.value = readArray(res);
        tencentVisible.value = true;
      } catch (error) {
        ElMessage.error(error.message || '查询腾讯模板失败');
      }
    };
    onMounted(fetchList);
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between"
        }, [_cache[19] || (_cache[19] = _createElementVNode("div", null, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "电子签模板"), _createElementVNode("p", {
          class: "mt-2 text-sm leading-6 text-slate-600"
        }, "维护平台电子签模板、签署方角色和控件定位，支撑后台发起腾讯电子签流程。")], -1)), _createElementVNode("div", {
          class: "flex flex-wrap gap-2"
        }, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary inline-flex items-center gap-2",
          onClick: loadTencentTemplates
        }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 4v6h6M20 20v-6h-6M20 9A8 8 0 006.7 4.7L4 7m0 8a8 8 0 0013.3 4.3L20 17"
        })], -1), _createTextVNode(" 拉取腾讯模板 ", -1)]))]), _createElementVNode("button", {
          type: "button",
          class: "btn-primary inline-flex items-center gap-2",
          onClick: openCreate
        }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 创建模板 ", -1)]))])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryCards.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.label,
            class: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm"
          }, [_createElementVNode("p", _hoisted_3, _toDisplayString(item.label), 1), _createElementVNode("p", _hoisted_4, _toDisplayString(item.value), 1)]);
        }), 128))]), _createElementVNode("div", _hoisted_5, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchList
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.keyword = $event),
            class: "form-search-input form-control-sm w-full",
            placeholder: "搜索模板名称或编码",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, filters.keyword]]), _cache[20] || (_cache[20] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: filters.templateType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.templateType = $event),
            placeholder: "请选择模板类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "文件模板",
              value: "FILE"
            }), _createVNode(_component_el_option, {
              label: "腾讯模板",
              value: "TENCENT_TEMPLATE"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "草稿",
              value: "DRAFT"
            }), _createVNode(_component_el_option, {
              label: "启用",
              value: "ENABLED"
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: "DISABLED"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_cache[23] || (_cache[23] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "模板"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "渠道"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "腾讯模板 ID"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "更新时间"), _createElementVNode("th", {
          class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[21] || (_cache[21] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, "正在加载模板...", -1)]))])) : !list.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[22] || (_cache[22] = [_createElementVNode("td", {
          colspan: "7",
          class: "data-table-empty"
        }, "暂无电子签模板", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(list.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.templateName || item.name || '-'), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(item.templateCode || item.code || item.id), 1)]), _createElementVNode("td", _hoisted_15, _toDisplayString(templateTypeText(item.templateType)), 1), _createElementVNode("td", _hoisted_16, _toDisplayString(item.channel || 'TENCENT'), 1), _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(blank)(item.tencentTemplateId)), 1), _createElementVNode("td", _hoisted_18, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', _unref(templateStatusClass)(item.status)])
          }, _toDisplayString(_unref(templateStatusText)(item.status)), 3)]), _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatDateTime)(item.updateTime || item.updatedAt || item.createTime) || '-'), 1), _createElementVNode("td", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "详情",
            "aria-label": "详情",
            onClick: $event => openDetail(item)
          }, "详情", 8, _hoisted_22), _createElementVNode("button", {
            class: "table-action-button is-indigo",
            title: "签署方",
            "aria-label": "签署方",
            onClick: $event => openParties(item)
          }, "签署方", 8, _hoisted_23), _createElementVNode("button", {
            class: "table-action-button is-teal",
            title: "控件",
            "aria-label": "控件",
            onClick: $event => openFields(item)
          }, "控件", 8, _hoisted_24), item.status !== 'ENABLED' ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-success",
            title: "启用",
            "aria-label": "启用",
            onClick: $event => toggleTemplate(item, true)
          }, "启用", 8, _hoisted_25)) : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-danger",
            title: "停用",
            "aria-label": "停用",
            onClick: $event => toggleTemplate(item, false)
          }, "停用", 8, _hoisted_26))])])]);
        }), 128))])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pagination.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])])]), _createVNode(_component_el_drawer, {
          modelValue: detailVisible.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => detailVisible.value = $event),
          title: "模板详情",
          size: "640px"
        }, {
          default: _withCtx(() => [detail.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("section", _hoisted_28, [_cache[28] || (_cache[28] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "基础信息", -1)), _createElementVNode("dl", _hoisted_29, [_createElementVNode("div", null, [_cache[24] || (_cache[24] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "模板名称", -1)), _createElementVNode("dd", _hoisted_30, _toDisplayString(detail.value.templateName || detail.value.name || '-'), 1)]), _createElementVNode("div", null, [_cache[25] || (_cache[25] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "模板编码", -1)), _createElementVNode("dd", _hoisted_31, _toDisplayString(detail.value.templateCode || detail.value.code || '-'), 1)]), _createElementVNode("div", null, [_cache[26] || (_cache[26] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "模板类型", -1)), _createElementVNode("dd", _hoisted_32, _toDisplayString(templateTypeText(detail.value.templateType)), 1)]), _createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("dt", {
            class: "text-slate-500"
          }, "腾讯模板 ID", -1)), _createElementVNode("dd", _hoisted_33, _toDisplayString(_unref(blank)(detail.value.tencentTemplateId)), 1)])])]), _createElementVNode("section", _hoisted_34, [_cache[29] || (_cache[29] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "签署方", -1)), _createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailParties.value, party => {
            return _openBlock(), _createElementBlock("div", {
              key: party.id || party.roleCode,
              class: "rounded-xl bg-slate-50 p-3 text-sm"
            }, [_createElementVNode("div", _hoisted_36, _toDisplayString(party.roleName || party.roleCode || '-'), 1), _createElementVNode("div", _hoisted_37, _toDisplayString(party.subjectType || '-') + " / " + _toDisplayString(party.approverType || '-') + " / 顺序 " + _toDisplayString(party.signOrder ?? '-'), 1)]);
          }), 128)), !detailParties.value.length ? (_openBlock(), _createElementBlock("p", _hoisted_38, "暂无签署方配置")) : _createCommentVNode("", true)])]), _createElementVNode("section", _hoisted_39, [_cache[30] || (_cache[30] = _createElementVNode("h3", {
            class: "text-sm font-semibold text-slate-900"
          }, "控件字段", -1)), _createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailFields.value, field => {
            return _openBlock(), _createElementBlock("div", {
              key: field.id || field.fieldCode,
              class: "rounded-xl bg-slate-50 p-3 text-sm"
            }, [_createElementVNode("div", _hoisted_41, _toDisplayString(field.fieldName || field.fieldCode || '-'), 1), _createElementVNode("div", _hoisted_42, _toDisplayString(field.fieldType || '-') + " / " + _toDisplayString(field.generateMode || 'POSITION') + " / 第 " + _toDisplayString(field.pageNo || '-') + " 页", 1)]);
          }), 128)), !detailFields.value.length ? (_openBlock(), _createElementBlock("p", _hoisted_43, "暂无控件配置")) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: createVisible.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => createVisible.value = $event),
          title: "创建电子签模板",
          width: "640px"
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            class: "btn-secondary",
            type: "button",
            onClick: _cache[10] || (_cache[10] = $event => createVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary ml-2",
            type: "button",
            disabled: submitting.value,
            onClick: submitCreate
          }, "保存", 8, _hoisted_44)]),
          default: _withCtx(() => [_createVNode(_component_el_form, {
            "label-width": "120px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "模板编码",
              required: ""
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => templateForm.templateCode = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, templateForm.templateCode]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "模板名称",
              required: ""
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => templateForm.templateName = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, templateForm.templateName]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "模板类型"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: templateForm.templateType,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => templateForm.templateType = $event),
                class: "form-select w-full"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "文件模板",
                  value: "FILE"
                }), _createVNode(_component_el_option, {
                  label: "腾讯模板",
                  value: "TENCENT_TEMPLATE"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "渠道"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => templateForm.channel = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, templateForm.channel]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "腾讯模板 ID"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => templateForm.tencentTemplateId = $event),
                class: "form-input w-full"
              }, null, 512), [[_vModelText, templateForm.tencentTemplateId]])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "备注"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => templateForm.remark = $event),
                class: "form-textarea w-full",
                rows: "3"
              }, null, 512), [[_vModelText, templateForm.remark]])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: partiesVisible.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => partiesVisible.value = $event),
          title: "配置签署方",
          width: "900px"
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            class: "btn-secondary",
            type: "button",
            onClick: _cache[12] || (_cache[12] = $event => partiesVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary ml-2",
            type: "button",
            disabled: submitting.value,
            onClick: submitParties
          }, "保存", 8, _hoisted_50)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partyRows.value, (party, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: party.key,
              class: "grid gap-3 rounded-2xl border border-slate-200 p-3 md:grid-cols-6"
            }, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => party.roleCode = $event,
              class: "form-input",
              placeholder: "角色编码"
            }, null, 8, _hoisted_46), [[_vModelText, party.roleCode]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => party.roleName = $event,
              class: "form-input",
              placeholder: "角色名称"
            }, null, 8, _hoisted_47), [[_vModelText, party.roleName]]), _createVNode(_component_el_select, {
              modelValue: party.subjectType,
              "onUpdate:modelValue": $event => party.subjectType = $event,
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "个人",
                value: "PERSON"
              }), _createVNode(_component_el_option, {
                label: "企业",
                value: "ORGANIZATION"
              })]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_select, {
              modelValue: party.approverType,
              "onUpdate:modelValue": $event => party.approverType = $event,
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "个人签署",
                value: "PERSON"
              }), _createVNode(_component_el_option, {
                label: "企业签署",
                value: "ORGANIZATION"
              }), _createVNode(_component_el_option, {
                label: "企业静默签署",
                value: "ORGANIZATION_AUTO_SIGN"
              }), _createVNode(_component_el_option, {
                label: "个人自动签署",
                value: "PERSON_AUTO_SIGN_RESERVED"
              })]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => party.signOrder = $event,
              type: "number",
              class: "form-input",
              placeholder: "顺序"
            }, null, 8, _hoisted_48), [[_vModelText, party.signOrder, void 0, {
              number: true
            }]]), _createElementVNode("button", {
              type: "button",
              class: "btn-danger-secondary",
              onClick: $event => removeParty(index)
            }, "删除", 8, _hoisted_49)]);
          }), 128)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: addParty
          }, "添加签署方")])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: fieldsVisible.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => fieldsVisible.value = $event),
          title: "配置控件字段",
          width: "1080px"
        }, {
          footer: _withCtx(() => [_createElementVNode("button", {
            class: "btn-secondary",
            type: "button",
            onClick: _cache[14] || (_cache[14] = $event => fieldsVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary ml-2",
            type: "button",
            disabled: submitting.value,
            onClick: submitFields
          }, "保存", 8, _hoisted_58)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_51, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldRows.value, (field, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: field.key,
              class: "grid gap-3 rounded-2xl border border-slate-200 p-3 md:grid-cols-8"
            }, [_withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => field.fieldCode = $event,
              class: "form-input",
              placeholder: "字段编码"
            }, null, 8, _hoisted_52), [[_vModelText, field.fieldCode]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => field.fieldName = $event,
              class: "form-input",
              placeholder: "字段名称"
            }, null, 8, _hoisted_53), [[_vModelText, field.fieldName]]), _createVNode(_component_el_select, {
              modelValue: field.fieldType,
              "onUpdate:modelValue": $event => field.fieldType = $event,
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "文本",
                value: "TEXT"
              }), _createVNode(_component_el_option, {
                label: "个人签名",
                value: "SIGNATURE"
              }), _createVNode(_component_el_option, {
                label: "企业公章",
                value: "SEAL"
              }), _createVNode(_component_el_option, {
                label: "骑缝章",
                value: "PAGING_SEAL"
              }), _createVNode(_component_el_option, {
                label: "法人章",
                value: "LEGAL_PERSON_SEAL"
              }), _createVNode(_component_el_option, {
                label: "勾选框",
                value: "CHECKBOX"
              }), _createVNode(_component_el_option, {
                label: "日期",
                value: "DATE"
              }), _createVNode(_component_el_option, {
                label: "金额",
                value: "AMOUNT"
              }), _createVNode(_component_el_option, {
                label: "图片",
                value: "IMAGE"
              })]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_select, {
              modelValue: field.generateMode,
              "onUpdate:modelValue": $event => field.generateMode = $event,
              class: "form-select"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "坐标",
                value: "POSITION"
              }), _createVNode(_component_el_option, {
                label: "关键字",
                value: "KEYWORD"
              }), _createVNode(_component_el_option, {
                label: "表单域",
                value: "FIELD"
              })]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => field.componentId = $event,
              class: "form-input",
              placeholder: "关键字/域名"
            }, null, 8, _hoisted_54), [[_vModelText, field.componentId]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => field.pageNo = $event,
              type: "number",
              class: "form-input",
              placeholder: "页码"
            }, null, 8, _hoisted_55), [[_vModelText, field.pageNo, void 0, {
              number: true
            }]]), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": $event => field.defaultValue = $event,
              class: "form-input",
              placeholder: "默认值/印章ID"
            }, null, 8, _hoisted_56), [[_vModelText, field.defaultValue]]), _createElementVNode("button", {
              type: "button",
              class: "btn-danger-secondary",
              onClick: $event => removeField(index)
            }, "删除", 8, _hoisted_57)]);
          }), 128)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: addField
          }, "添加控件")])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
          modelValue: tencentVisible.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => tencentVisible.value = $event),
          title: "腾讯模板列表",
          width: "860px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("table", _hoisted_61, [_cache[32] || (_cache[32] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "模板 ID"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "模板名称"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "状态")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tencentTemplates.value, item => {
            return _openBlock(), _createElementBlock("tr", {
              key: item.templateId || item.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_62, _toDisplayString(item.templateId || item.id), 1), _createElementVNode("td", _hoisted_63, _toDisplayString(item.templateName || item.name || '-'), 1), _createElementVNode("td", _hoisted_64, _toDisplayString(item.status || '-'), 1)]);
          }), 128)), !tencentTemplates.value.length ? (_openBlock(), _createElementBlock("tr", _hoisted_65, [...(_cache[31] || (_cache[31] = [_createElementVNode("td", {
            colspan: "3",
            class: "data-table-empty"
          }, "暂无腾讯模板", -1)]))])) : _createCommentVNode("", true)])])])])]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      });
    };
  }
};